import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditofivejyotilingapackage() {



    const cardData = {





keyword: "Shirdi to 5 Jyotirlinga Package",

headingDescription: "Sai Shirdi Cab offers a comfortable and customizable Shirdi to 5 Jyotirlinga Package for devotees and families planning a multi-temple pilgrimage across Maharashtra. The package is designed for travelers who want to visit the five revered Jyotirlinga temples of Maharashtra in a planned private cab journey. Customers can choose suitable vehicles such as Sedan, Ertiga, Innova, Innova Crysta, SUV, or other spacious options depending on group size and luggage requirements. The package can be arranged as a multi-day pilgrimage with flexible departure timings, temple visits, overnight stays, and return arrangements. With experienced drivers, clean and well-maintained vehicles, comfortable seating, and itinerary-based travel, Sai Shirdi Cab makes it easier for devotees to travel between the major Jyotirlinga destinations without depending on public transportation. The itinerary can be customized according to darshan preferences, available time, family requirements, and the number of travelers.",

topPlaces: [
{
title: "Grishneshwar Jyotirlinga",
description: "Grishneshwar Jyotirlinga near Ellora is one of the five revered Jyotirlinga temples in Maharashtra and an important stop in this pilgrimage package. Devotees traveling from Shirdi can include temple darshan as part of their planned multi-Jyotirlinga journey. Private cab transportation provides convenient travel with flexible timing for families and pilgrimage groups."
},
{
title: "Trimbakeshwar Jyotirlinga",
description: "Trimbakeshwar Jyotirlinga near Nashik is another major pilgrimage destination included in the five Jyotirlinga journey. The temple holds great religious importance and attracts devotees throughout the year. Travelers can visit Trimbakeshwar as part of a customized cab itinerary with comfortable transportation and suitable time for darshan."
},
{
title: "Bhimashankar Jyotirlinga",
description: "Bhimashankar Jyotirlinga is situated in the scenic Sahyadri region and is one of Maharashtra's most important Shiva pilgrimage destinations. Devotees can include Bhimashankar in their multi-day Shirdi Jyotirlinga package. Private cab service allows families and groups to travel comfortably while following their preferred pilgrimage schedule."
},
{
title: "Aundha Nagnath Jyotirlinga",
description: "Aundha Nagnath is a highly revered Shiva temple in Maharashtra and is traditionally included among the important Jyotirlinga pilgrimage destinations. Travelers can include the temple in a planned five-Jyotirlinga circuit starting from Shirdi. A private cab provides flexibility for long-distance travel, temple visits, meal breaks, and overnight arrangements."
},
{
title: "Parli Vaijnath Jyotirlinga",
description: "Parli Vaijnath is a prominent Shiva pilgrimage destination in Maharashtra and completes the five-Jyotirlinga temple circuit covered through this package. Devotees can plan their visit according to their preferred darshan timings and overall journey duration. Comfortable private cab service makes multi-day pilgrimage travel more convenient for families and groups."
}
],









"services": [
{
"name": "Shirdi to 5 Jyotirlinga Package",
"description": "Shirdi to 5 Jyotirlinga Package provides private transportation for devotees planning to visit multiple Jyotirlinga temples from Shirdi. The itinerary can be arranged according to the selected temples, travel dates, passenger count, preferred vehicle, darshan requirements, and available tour duration."
},
{
"name": "Shirdi 5 Jyotirlinga Tour Package",
"description": "Shirdi 5 Jyotirlinga Tour Package is suitable for families, pilgrims, and groups planning a multi-temple pilgrimage journey from Shirdi. The tour can be organized with a suitable private vehicle and a customized itinerary based on sightseeing, temple visits, travel time, and return requirements."
},
{
"name": "5 Jyotirlinga Tour Package from Shirdi",
"description": "5 Jyotirlinga Tour Package from Shirdi offers a convenient way to plan a pilgrimage covering selected Jyotirlinga temples from Shirdi. Travelers can choose suitable transportation, tour duration, pickup arrangements, passenger capacity, and temple-wise travel plans according to their requirements."
},
{
"name": "Shirdi to 5 Jyotirlinga Cab",
"description": "Shirdi to 5 Jyotirlinga Cab provides private transportation for devotees traveling from Shirdi to multiple Jyotirlinga destinations. The cab can be selected according to group size, luggage, preferred vehicle category, temple itinerary, travel dates, and one-way or return journey requirements."
},
{
"name": "Shirdi to 5 Jyotirlinga Taxi",
"description": "Shirdi to 5 Jyotirlinga Taxi offers private point-to-point transportation for passengers planning an extended Jyotirlinga pilgrimage. The journey can be arranged according to the selected temples, passenger count, travel schedule, vehicle preference, sightseeing requirements, and tour duration."
},
{
"name": "Shirdi 5 Jyotirlinga Cab Package",
"description": "Shirdi 5 Jyotirlinga Cab Package provides a private vehicle option for families and groups visiting multiple Jyotirlinga temples during their pilgrimage. Cab arrangements can be planned with suitable seating, luggage capacity, temple stops, travel dates, and customized itinerary requirements."
},
{
"name": "Shirdi 5 Jyotirlinga Taxi Package",
"description": "Shirdi 5 Jyotirlinga Taxi Package is designed for travelers looking for private taxi transportation during a multi-destination temple tour from Shirdi. The package can be organized according to the preferred vehicle, passenger count, temple route, travel duration, and return schedule."
},
{
"name": "5 Jyotirlinga Cab Service from Shirdi",
"description": "5 Jyotirlinga Cab Service from Shirdi provides private transportation for devotees planning to visit multiple sacred Jyotirlinga temples. Travelers can arrange the service according to their pilgrimage itinerary, group size, preferred vehicle, travel dates, temple visits, and required trip duration."
},
{
"name": "5 Jyotirlinga Taxi Package from Shirdi",
"description": "5 Jyotirlinga Taxi Package from Shirdi offers a convenient private transportation solution for devotees undertaking a multi-temple pilgrimage. The taxi journey can be planned around selected temple destinations, passenger requirements, sightseeing preferences, travel schedule, and return arrangements."
},
{
"name": "Shirdi Jyotirlinga Tour Package",
"description": "Shirdi Jyotirlinga Tour Package provides private travel arrangements for pilgrims interested in exploring Jyotirlinga temples from Shirdi. The itinerary can be customized according to the number of temples, available travel days, passenger count, preferred vehicle, darshan plans, and sightseeing requirements."
},
{
"name": "Shirdi Jyotirlinga Darshan Package",
"description": "Shirdi Jyotirlinga Darshan Package is suitable for devotees planning temple visits from Shirdi with organized private transportation. The journey can be arranged according to darshan preferences, selected temples, passenger count, vehicle category, travel dates, and the desired pilgrimage schedule."
},
{
"name": "Shirdi to Trimbakeshwar Jyotirlinga Cab",
"description": "Shirdi to Trimbakeshwar Jyotirlinga Cab provides private transportation for devotees traveling from Shirdi to Trimbakeshwar Temple. The cab can be arranged for darshan trips, one-way travel, return journeys, family pilgrimages, and customized itineraries according to passenger and travel requirements."
},
{
"name": "Shirdi to Bhimashankar Jyotirlinga Cab",
"description": "Shirdi to Bhimashankar Jyotirlinga Cab offers private transportation for pilgrims visiting Bhimashankar from Shirdi. Travelers can select a suitable vehicle according to passenger count, luggage requirements, travel schedule, darshan plans, and one-way or round-trip transportation needs."
},
{
"name": "Shirdi to Grishneshwar Jyotirlinga Cab",
"description": "Shirdi to Grishneshwar Jyotirlinga Cab provides convenient private transportation for devotees planning to visit Grishneshwar Temple from Shirdi. The journey can be organized according to temple visit timing, passenger requirements, preferred vehicle, sightseeing plans, and return travel schedule."
},
{
"name": "Shirdi to 5 Jyotirlinga One Day Package",
"description": "Shirdi to 5 Jyotirlinga One Day Package is intended for travelers planning a compact pilgrimage itinerary covering selected temple destinations within a limited schedule. Private transportation can be arranged according to the route, passenger count, vehicle category, temple visit requirements, and available travel time."
},
{
"name": "Shirdi to 5 Jyotirlinga Two Day Package",
"description": "Shirdi to 5 Jyotirlinga Two Day Package provides additional travel time for devotees planning a multi-temple pilgrimage from Shirdi. The itinerary can be organized with private transportation, suitable overnight arrangements, temple stops, sightseeing requirements, passenger capacity, and preferred travel schedule."
},
{
"name": "Shirdi to 5 Jyotirlinga Three Day Package",
"description": "Shirdi to 5 Jyotirlinga Three Day Package offers a more relaxed itinerary for travelers planning an extended Jyotirlinga pilgrimage from Shirdi. The trip can be customized according to selected temples, overnight stays, passenger count, preferred vehicle, darshan timing, sightseeing, and return plans."
},
{
"name": "Shirdi 5 Jyotirlinga Innova Cab",
"description": "Shirdi 5 Jyotirlinga Innova Cab provides spacious private transportation for families and small groups undertaking a multi-temple pilgrimage. The Innova offers comfortable seating and luggage capacity and can be arranged according to the temple itinerary, travel duration, passenger count, and sightseeing requirements."
},
{
"name": "Shirdi 5 Jyotirlinga Ertiga Cab",
"description": "Shirdi 5 Jyotirlinga Ertiga Cab is a practical option for families and small groups planning a Jyotirlinga tour from Shirdi. The Ertiga can be arranged for extended temple travel with suitable seating, luggage space, customized stops, travel dates, and one-way or return journey requirements."
},
{
"name": "Jyotirlinga Tour from Shirdi",
"description": "Jyotirlinga Tour from Shirdi provides private transportation for devotees planning to visit one or more Jyotirlinga temples during their pilgrimage. Travelers can choose suitable vehicle options and organize the itinerary according to temple destinations, group size, travel duration, darshan requirements, and sightseeing preferences."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides private cab and taxi transportation for devotees traveling from Shirdi to Jyotirlinga temples and other pilgrimage destinations. Suitable sedan, Ertiga, Innova, Innova Crysta, and larger vehicle options can be arranged for darshan tours, multi-day pilgrimage packages, temple visits, and customized travel plans."
}
],
"tableData": [
["Shirdi to 5 Jyotirlinga Package", "Shirdi 5 Jyotirlinga Tour Package"],
["5 Jyotirlinga Tour Package from Shirdi", "Shirdi to 5 Jyotirlinga Cab"],
["Shirdi to 5 Jyotirlinga Taxi", "Shirdi 5 Jyotirlinga Cab Package"],
["Shirdi 5 Jyotirlinga Taxi Package", "5 Jyotirlinga Cab Service from Shirdi"],
["5 Jyotirlinga Taxi Package from Shirdi", "Shirdi Jyotirlinga Tour Package"],
["Shirdi Jyotirlinga Darshan Package", "Shirdi to Trimbakeshwar Jyotirlinga Cab"],
["Shirdi to Bhimashankar Jyotirlinga Cab", "Shirdi to Grishneshwar Jyotirlinga Cab"],
["Shirdi to 5 Jyotirlinga One Day Package", "Shirdi to 5 Jyotirlinga Two Day Package"],
["Shirdi to 5 Jyotirlinga Three Day Package", "Shirdi 5 Jyotirlinga Innova Cab"],
["Shirdi 5 Jyotirlinga Ertiga Cab", "Jyotirlinga Tour from Shirdi"],
["Sai Shirdi Cabs", "Shirdi to 5 Jyotirlinga Package"]
]
,















    whychoose: [
        { 
            WhyChooseheading: "Shirdi to 5 Jyotirlinga Package for a Complete Pilgrimage Journey", 
            WhyChoosedescription: "Sai Shirdi Cabs offers private cab packages from Shirdi for devotees planning a multi-temple pilgrimage covering five Jyotirlinga destinations. The package is suitable for families, senior citizens, friends, and religious groups who prefer travelling together in a dedicated vehicle with a flexible itinerary." 
        }, 
        { 
            WhyChooseheading: "Private Cab for Multi-Temple Pilgrimage", 
            WhyChoosedescription: "Travel between multiple Jyotirlinga temples in a private vehicle instead of arranging separate transportation for each leg. A dedicated cab makes it easier to coordinate temple visits, accommodation stops, luggage, and the overall pilgrimage schedule." 
        }, 
        { 
            WhyChooseheading: "Customized Pilgrimage Itinerary", 
            WhyChoosedescription: "Plan the journey according to your preferred travel dates, temple visit sequence, overnight stays, and available time. The itinerary can be discussed in advance so your Shirdi pilgrimage and Jyotirlinga visits are organized around your requirements." 
        }, 
        { 
            WhyChooseheading: "Suitable for Families & Devotee Groups", 
            WhyChoosedescription: "Families, friends, senior citizens, and small pilgrimage groups can travel together in a suitable vehicle. Vehicle selection can be planned according to passenger numbers, luggage quantity, and the expected duration of the multi-day journey." 
        }, 
        { 
            WhyChooseheading: "Convenient Pickup from Shirdi", 
            WhyChoosedescription: "Begin your Jyotirlinga pilgrimage from your Shirdi hotel, residence, temple area, or another convenient pickup point. The departure can be coordinated according to your Sai Baba Darshan schedule and planned pilgrimage itinerary." 
        }, 
        { 
            WhyChooseheading: "One Vehicle Throughout the Pilgrimage", 
            WhyChoosedescription: "A private cab arrangement allows your group to continue the pilgrimage in the same dedicated vehicle across the planned destinations. This can make luggage management, group coordination, and intercity travel more convenient." 
        }, 
        { 
            WhyChooseheading: "Flexible Stops & Return Arrangements", 
            WhyChoosedescription: "Discuss required sightseeing stops, overnight halts, temple visits, and return or onward travel arrangements while planning the package. The itinerary can be structured according to the destinations included in your pilgrimage plan." 
        }, 
        { 
            WhyChooseheading: "Book Shirdi to 5 Jyotirlinga Package with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your preferred travel dates, passenger count, Shirdi pickup location, Jyotirlinga itinerary, overnight requirements, luggage details, and vehicle preference with Sai Shirdi Cabs to plan a suitable private pilgrimage package." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I book a Shirdi to 5 Jyotirlinga Package?", 
        answer: "Yes, Sai Shirdi Cabs provides private cab packages for devotees planning a multi-temple pilgrimage from Shirdi covering five Jyotirlinga destinations." 
    }, 
    { 
        question: "Can I start the 5 Jyotirlinga pilgrimage from Shirdi?", 
        answer: "Yes, the pilgrimage can be planned with pickup from your Shirdi hotel, residence, temple area, or another convenient location according to your travel schedule." 
    }, 
    { 
        question: "Can I customize the 5 Jyotirlinga itinerary?", 
        answer: "Yes, travellers can discuss their preferred travel dates, temple sequence, overnight stays, sightseeing stops, return arrangements, and other itinerary requirements." 
    }, 
    { 
        question: "Is the 5 Jyotirlinga package suitable for families?", 
        answer: "Yes, families can book a private cab and select a suitable vehicle according to passenger numbers, luggage requirements, and the expected duration of the pilgrimage." 
    }, 
    { 
        question: "Can senior citizens travel on the 5 Jyotirlinga pilgrimage?", 
        answer: "Yes, private cab travel allows families and groups travelling with senior citizens to remain together in a dedicated vehicle throughout the planned pilgrimage." 
    }, 
    { 
        question: "Which vehicles are available for the 5 Jyotirlinga Package?", 
        answer: "Vehicle options may include sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and larger vehicles depending on passenger count, luggage, and the length of the pilgrimage." 
    }, 
    { 
        question: "Can I carry luggage during the Jyotirlinga tour?", 
        answer: "Yes, passengers can carry luggage according to the storage capacity of the selected vehicle. Larger or additional baggage requirements should be mentioned while booking." 
    }, 
    { 
        question: "Can I include Shirdi Sai Baba Darshan in the package?", 
        answer: "Yes, travellers can discuss an itinerary that includes Sai Baba Darshan in Shirdi along with the planned Jyotirlinga temple visits, subject to the available travel schedule." 
    }, 
    { 
        question: "Can I arrange overnight stays during the pilgrimage?", 
        answer: "Yes, overnight halts can be considered while planning a multi-day pilgrimage, depending on the selected destinations, travel schedule, and overall itinerary." 
    }, 
    { 
        question: "How can I book Shirdi to 5 Jyotirlinga Package with Sai Shirdi Cabs?", 
        answer: "Share your Shirdi pickup point, travel dates, passenger details, preferred Jyotirlinga destinations, overnight requirements, luggage information, and vehicle preference with Sai Shirdi Cabs to plan the package." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Rajendra Pawar", 
        feedback: "We planned a family pilgrimage from Shirdi covering five Jyotirlinga temples. Having one private cab for the journey made it much easier for everyone to travel together, manage our luggage, and follow our planned temple schedule.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Meenal Deshmukh", 
        feedback: "Our group wanted a dedicated vehicle for a multi-day Jyotirlinga pilgrimage after visiting Shirdi. The private travel arrangement gave us the flexibility to organize temple visits and overnight stops according to our itinerary.", 
        rating: 5 
    } 
];



    

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to 5 Jyotirlinga Package",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-5-jyotirlinga-package.webp",
  "description":
    "Book Shirdi to 5 Jyotirlinga Package with Sai Shirdi Cabs for a comfortable and convenient pilgrimage tour covering five important Jyotirlinga temples from Shirdi. Our customized 5 Jyotirlinga tour packages are suitable for devotees, families, senior citizens, and groups, with flexible travel plans, professional drivers, comfortable vehicles, convenient temple visits, sightseeing assistance, and reliable outstation cab services. Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller according to your group size and travel requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-5-jyotirlinga-package"
  }
};



    return (
        <div>

<Helmet>
  <title>Shirdi to 5 Jyotirlinga Package | Jyotirlinga Tour from Shirdi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi to 5 Jyotirlinga Package with Sai Shirdi Cabs for a comfortable pilgrimage tour covering five Jyotirlinga temples from Shirdi. Get Sedan, Ertiga, Innova, Innova Crysta and Tempo Traveller with professional drivers, flexible tour plans, convenient temple travel, reliable service and affordable fares."
  />

  <meta
    name="keywords"
    content="Shirdi to 5 Jyotirlinga Package, Shirdi 5 Jyotirlinga Tour Package, 5 Jyotirlinga Tour Package from Shirdi, Shirdi to 5 Jyotirlinga Cab, Shirdi to 5 Jyotirlinga Taxi, Shirdi 5 Jyotirlinga Cab Package, Shirdi 5 Jyotirlinga Taxi Package, 5 Jyotirlinga cab service from Shirdi, 5 Jyotirlinga taxi service from Shirdi, Shirdi to 5 Jyotirlinga Cab Service, Shirdi to 5 Jyotirlinga Taxi Service, Shirdi 5 Jyotirlinga Tour, Shirdi 5 Jyotirlinga Yatra Package, Shirdi Jyotirlinga Tour Package, Shirdi Jyotirlinga Yatra Taxi, Shirdi Jyotirlinga Yatra Cab, Shirdi to Jyotirlinga Tour Package, 5 Jyotirlinga Yatra from Shirdi, 5 Jyotirlinga Tour from Shirdi, 5 Jyotirlinga Taxi from Shirdi, 5 Jyotirlinga Cab from Shirdi, Shirdi 5 Jyotirlinga Taxi Service, Shirdi 5 Jyotirlinga Cab Service, Shirdi Jyotirlinga Cab Booking, Shirdi Jyotirlinga Taxi Booking, Shirdi to 5 Jyotirlinga Taxi Booking, Shirdi to 5 Jyotirlinga Cab Booking, Shirdi to 5 Jyotirlinga Tour Cab, Shirdi to 5 Jyotirlinga Tour Taxi, Shirdi 5 Jyotirlinga Package Booking, 5 Jyotirlinga Package Booking from Shirdi, Shirdi to 5 Jyotirlinga One Way Cab, Shirdi to 5 Jyotirlinga Round Trip Cab, Shirdi 5 Jyotirlinga Round Trip Taxi, Shirdi Jyotirlinga Pilgrimage Package, Shirdi Jyotirlinga Pilgrimage Cab, Shirdi Jyotirlinga Pilgrimage Taxi, Shirdi Jyotirlinga Darshan Package, Shirdi Jyotirlinga Darshan Cab, Shirdi Jyotirlinga Darshan Taxi, Shirdi to 5 Jyotirlinga Tour Package Cost, Shirdi to 5 Jyotirlinga Package Price, Shirdi to 5 Jyotirlinga Taxi Fare, Shirdi to 5 Jyotirlinga Cab Fare, Affordable 5 Jyotirlinga Tour Package from Shirdi, Best 5 Jyotirlinga Tour Package from Shirdi, 5 Jyotirlinga Private Cab from Shirdi, 5 Jyotirlinga Family Cab from Shirdi, 5 Jyotirlinga Group Taxi from Shirdi, Shirdi to 5 Jyotirlinga Sedan Cab, Shirdi to 5 Jyotirlinga Swift Dzire Cab, Shirdi to 5 Jyotirlinga Ertiga Cab, Shirdi to 5 Jyotirlinga Innova Cab, Shirdi to 5 Jyotirlinga Innova Crysta Cab, Shirdi to 5 Jyotirlinga Tempo Traveller, Shirdi to 5 Jyotirlinga Car Rental, Shirdi to 5 Jyotirlinga Car Hire, Shirdi 5 Jyotirlinga Outstation Cab, Shirdi 5 Jyotirlinga Outstation Taxi, Shirdi 5 Jyotirlinga Travel Service, Shirdi 5 Jyotirlinga Tour Service, Shirdi to 5 Jyotirlinga Religious Tour, Shirdi to 5 Jyotirlinga Temple Tour, Shirdi to 5 Jyotirlinga Pilgrimage Tour, Shirdi to 5 Jyotirlinga Yatra Cab, Shirdi to 5 Jyotirlinga Yatra Taxi, Shirdi 5 Jyotirlinga Tour by Car, Sai Shirdi Cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditofivejyotilingapackage;